import React from 'react';
import { Link } from 'react-router-dom';
import { WordShape } from '../shapes';
import DateMaster from '../stores/utils/date_master';

export default class NewestWord extends React.Component {

  static propTypes = {
    trendingWord: WordShape
  }

  render() {
    return(
      <div className='trending-word row'>
        <div className='col-6'>
          <Link to={ `/words/${this.props.trendingWord.get('wordText')}` } className='word-text'>{ this.props.trendingWord.get('wordText') }</Link>
        </div>
        <div className='col-6 item-meta'>
          { DateMaster.timeSince(this.props.trendingWord.get('lastTackedAt')) } ago
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/newest_word.jsx